module.exports = __webpack_public_path__ + "static/media/2 eagle realistic black and grey arm sleeve.1280x1707.7a3b04ba.webp";